var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tour",
      class: { "tour--anchored": _vm.anchored },
      style: _vm.rootStyle
    },
    [
      _vm.anchored && !_vm.disable && _vm.targetRect
        ? _c("div", {
            staticClass: "tour-spotlight",
            style: _vm.spotlightStyle
          })
        : _vm._e(),
      !_vm.disable
        ? _c(
            "div",
            {
              staticClass: "tour-info",
              class: { "tour-info--anchored": _vm.anchored },
              style: _vm.anchored ? _vm.cardStyle : null
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "background-color": "white",
                        width: "16px",
                        height: "16px"
                      },
                      attrs: { icon: "", "aria-label": "Fechar tour" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("closeTour")
                        }
                      }
                    },
                    [_c("icon-svg", { attrs: { name: "close", size: "6" } })],
                    1
                  )
                ],
                1
              ),
              _c(
                "p",
                { staticClass: "text-white text-sm font-medium mt-2 px-2" },
                [_vm._v(" " + _vm._s(_vm.stepsTour[_vm.currentStep]) + " ")]
              ),
              _c(
                "div",
                { staticClass: "tour-steps-points" },
                _vm._l(_vm.stepsTour, function(item, index) {
                  return _c("div", {
                    key: index,
                    staticClass: "dot",
                    class: { "bg-primary": _vm.currentStep === index }
                  })
                }),
                0
              ),
              _vm.currentStep !== _vm.stepsTour.length - 1
                ? _c(
                    "div",
                    { staticClass: "tour-bottom" },
                    [
                      _c(
                        "BaseButton",
                        {
                          staticStyle: {
                            "background-color": "white",
                            color: "var(--primary)"
                          },
                          attrs: { minWidth: "80px" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("closeTour")
                            }
                          }
                        },
                        [_vm._v(" Pular o tour ")]
                      ),
                      _c(
                        "BaseButton",
                        {
                          attrs: { primary: "", minWidth: "80px" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("nextStep")
                            }
                          }
                        },
                        [_vm._v(" Próximo ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "tour-bottom" },
                    [
                      _c(
                        "BaseButton",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { primary: "" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("nextStep")
                            }
                          }
                        },
                        [_vm._v(" Concluir ")]
                      )
                    ],
                    1
                  )
            ]
          )
        : _vm._e(),
      !_vm.disable && !_vm.anchored
        ? _c("div", { staticClass: "arc" })
        : _vm._e(),
      _vm._t("content")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }